import {useQuery} from "@tanstack/react-query";
import {SiteBunnyAdminError, toSiteBunnyAdminError} from "@/error";
import alarmRepository from "@/repository/AlarmRepository";
import {Notice} from "@/model/alarm/Notice";

const getData = async () => {
    try {
        const {data} = await alarmRepository.getSendNoticeHistory();
        return data.result.content;
    } catch (e) {
        throw toSiteBunnyAdminError(e);
    }
}


const useNoticeHistory = () => {
    return useQuery<Notice[], SiteBunnyAdminError>({
        queryKey: ['noticeHistory'],
        queryFn: async () => getData(),
    })
}

export default useNoticeHistory;

